import React from 'react';
import {Button} from 'antd';
import {ROUTES} from '../../utils/ROUTES';

const AiInfoModal = ({buttonClassName, buttonSize = 'default'}) => {
	return (
		<Button
			type="link"
			size={buttonSize || 'default'}
			className={`bg-backgroundGreyBlue hover:bg-lightBlue transition-colors ${buttonClassName}`}
			href={ROUTES.AI_CANDIDATE_FEEDBACK}
			target="_blank">
			Learn more
		</Button>
	);
};

export default AiInfoModal;
